module.exports = __webpack_public_path__ + "img/8.c6df4a55.png";